<ngb-tabset>
  <ngb-tab (select)="selectedTab = 'automation-admin';" title="{{'MISONET Mappings' | translate}}">
    <ng-template ngbTabContent>
      <qm-automation-admin></qm-automation-admin>
    </ng-template>
  </ngb-tab>
  <ngb-tab (select)="selectedTab = 'vivo-admin';" title="{{'VIVO Mappings' | translate}}">
    <ng-template ngbTabContent>
      <qm-vivo-admin></qm-vivo-admin>
    </ng-template>
  </ngb-tab>
  <ngb-tab (select)="selectedTab = 'app-version';" title="{{'Versions' | translate}}">
    <ng-template ngbTabContent>
      <qm-app-version></qm-app-version>
    </ng-template>
  </ngb-tab>
</ngb-tabset>
